
import Vue from 'vue';

export default Vue.extend({
  name: 'DeferredMount',

  data() {
    return {
      elem: undefined as Element | undefined,
    };
  },

  mounted() {
    this.elem = this.$refs.elem as Element;
  },

});
